import { render, staticRenderFns } from "./UploadMultipleDialog.vue?vue&type=template&id=5c477b3d&scoped=true&"
import script from "./UploadMultipleDialog.vue?vue&type=script&lang=js&"
export * from "./UploadMultipleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c477b3d",
  null
  
)

export default component.exports